import React from 'react'
import AppDialog from 'components/AppDialog'
import api, { MetadataEntity } from 'api'
import { EntityFormData } from './EntityFormData'
import { AppForm } from 'components/AppFormLayout/AppForm'

interface Props {
	mode: number
	afterSave?: () => void
	metadataEntity: MetadataEntity
}
// 新建数据表
export default class EntityFormPage extends React.Component<Props> {
	saveFormData = async () => {
		let metadataEntity: MetadataEntity = {}
		if (!metadataEntity) return
		let res = await api.modeling.entity.createTable(metadataEntity)
		if (!res) {
			return
		}
		this.props.afterSave && this.props.afterSave()
		AppDialog.close()
	}

	FormActionData = [
		{ title: '开始设计表', id: 'btnSave', type: 'primary', action: this.saveFormData },
	]
	render() {
		let formData = this.props.metadataEntity
		return (
          <AppForm
            defaultTabId={0}
            appFormTabList={EntityFormData}
            appFormActionList={this.FormActionData}
            mode={0}
            // ref={this.appFormRef}
          />
		
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/EntityFormPage.tsx